/* Lake Life Designs — Carousel Init (carousel-init.js)
   Wires prev/next buttons to their scrollable tracks via data-carousel-* attributes.
   Runs after all other scripts have injected their content.
   Works for both product-recs and nearby-lakes carousels. */
(function () {
  'use strict';

  function initCarousel(id) {
    var track   = document.querySelector('[data-carousel-track="' + id + '"]');
    var prevBtn = document.querySelector('[data-carousel-prev="' + id + '"]');
    var nextBtn = document.querySelector('[data-carousel-next="' + id + '"]');

    if (!track || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      /* Use actual card width if available, else fall back to 200px */
      var card = track.querySelector('.rec-card');
      return card ? card.offsetWidth + 16 : 200;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  }

  /* Run after DOM is ready */
  function init() {
    initCarousel('recs');
    initCarousel('nearby');
  }

  /* Also re-run after a short delay to catch async-injected content */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      setTimeout(init, 1000);
    });
  } else {
    init();
    setTimeout(init, 1000);
  }

})();
